import createCategoriesMap from 'apps/navigation/utils/createCategoriesMap';
import {
  OR_REQUEST_SUGGESTED_ORDER,
  OR_RECEIVE_SUGGESTED_ORDER,
  OR_OPEN_CATEGORY,
  OR_SHOW_NAVIGATION_PAGE,
  OR_HIDE_NAVIGATION_PAGE,
  OR_SO_CATEGORY_FILTER_UPDATE,
  OR_SO_FREQUENCY_FILTER_UPDATE,
} from '../../actions/management/suggestedOrder';

export const initialState = {
  categories: [],
  categoriesMap: {},
  currentlyOpenCategoryId: null,
  navigationPageVisible: false,
};

export default function suggestedOrderNavigationReducer(state = initialState, action) {
  switch (action.type) {
    case OR_RECEIVE_SUGGESTED_ORDER:
      return {
        ...state,
        categories: action.categories,
        categoriesMap: createCategoriesMap(action.categories),
      };
    case OR_OPEN_CATEGORY:
      return { ...state, currentlyOpenCategoryId: action.categoryId };
    case OR_SO_CATEGORY_FILTER_UPDATE:
      if (action.categoryId) {
        return state;
      }
      return { ...state, currentlyOpenCategoryId: null };
    case OR_SO_FREQUENCY_FILTER_UPDATE:
      return { ...state, currentlyOpenCategoryId: null };
    case OR_SHOW_NAVIGATION_PAGE:
      return { ...state, navigationPageVisible: true };
    case OR_HIDE_NAVIGATION_PAGE:
    case OR_REQUEST_SUGGESTED_ORDER:
      return { ...state, navigationPageVisible: false };
    default:
      return state;
  }
}
